import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { SimNaoEnum } from 'components/form'

import { ConsultaSeguimentoPergunta20Model } from './model-consultaSeguimentoPergunta20'
import { hasPergunta20ExemplosAnySim, isPergunta20ExemplosAllNao } from './utils-consultaSeguimentoPergunta20'

export const PERGUNTA_20_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta20Model> = {
  PERGUNTA_20_HEADER: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: 'PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR',
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_20_EXEMPLOS',
      },
    ],
  },
  PERGUNTA_20_GOSTA_DE_PULAR_OU_BALANCAR: {
    scrollConditions: [
      {
        if: (value) => value === SimNaoEnum.SIM,
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (value) => value === SimNaoEnum.NAO,
        scrollTo: 'PERGUNTA_20_EXEMPLOS',
      },
    ],
    dependsOn: 'PERGUNTA_20_HEADER',
  },
  PERGUNTA_20_EXEMPLOS: {
    scrollConditions: [
      {
        if: (_, allValues) => isPergunta20ExemplosAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (_, allValues) => hasPergunta20ExemplosAnySim(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_20_HEADER',
  },
}
